const dealCandidate = {
  id: null,
  dealId: null,
  existingUserId: null,
  fullName: null,
  firstName: null,
  lastName: null,
  emailAddress: null,
  createdBy: null,
  securityRoles: null,
  candidateType: null
}

export default () => Object.assign({}, dealCandidate)
